import { useEffect, useState } from "react";
// Material Dashboard 2 React example components
import DataTable from "examples/Tables/DataTable";

// Material Dashboard 2 React components
import MDTypography from "components/MDTypography";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import { Stack, TextField } from "@mui/material";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

const columns = [
  { Header: "Clients", accessor: "client", width: "50%", align: "left" },
  { Header: "Date", accessor: "createdAt", align: "center" },
  { Header: "Provénance", accessor: "provenance", align: "center" },
];

function formatDate(date) {
  const today = date.split("-");
  const dd = today[0];

  const mm = parseInt(today[1], 10) - 1;
  const yyyy = today[2];

  return new Date(yyyy, mm, dd);
}

function SalesTableData({ subscriptions }) {
  const [dataAfterSearch, setDataAfterSearch] = useState([]);
  const [fields, setFields] = useState({
    dateDebut: { value: null },
    dateFin: { value: null },
  });

  const resetSearch = () => {
    setFields({
      dateDebut: { value: null },
      dateFin: { value: null },
    });
    setDataAfterSearch(subscriptions);
  };

  const filterData = (dateDebut, dateFin) => {
    let data = subscriptions;
    if (dateDebut !== null) data = data.filter((s) => dateDebut <= formatDate(s.createdAt));
    if (dateFin !== null) data = data.filter((s) => formatDate(s.createdAt) <= dateFin);

    return data;
  };

  useEffect(() => {
    setDataAfterSearch(filterData(fields.dateDebut.value, fields.dateFin.value));
  }, []);

  const handleChangeSearch = (name, value) => {
    setFields((f) => ({
      ...f,
      [name]: { value },
    }));
    setDataAfterSearch(
      filterData(
        name === "dateDebut" ? value : fields.dateDebut.value,
        name === "dateFin" ? value : fields.dateFin.value
      )
    );

    if (
      (name === "dateDebut" ? value : fields.dateDebut.value) === null &&
      (name === "dateFin" ? value : fields.dateFin.value) === null
    )
      setDataAfterSearch(subscriptions);
  };

  const rows = dataAfterSearch.map((subscription) => ({
    client: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {subscription.client.fullname}
      </MDTypography>
    ),
    createdAt: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {subscription.createdAt}
      </MDTypography>
    ),
    provenance: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {subscription.provenance ? subscription.provenance : "Pas de povénance"}
      </MDTypography>
    ),
  }));

  return (
    <>
      <MDBox
        sx={{
          p: 1,
          m: 1,
        }}
      >
        <Stack justifyContent="right" direction={{ xs: "column", md: "row" }} spacing={1}>
          <div>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Stack spacing={1} sx={{ width: "100%", ml: 1, my: 1 }} direction="row">
                <DesktopDatePicker
                  label="Date début"
                  inputFormat="dd/MM/yyyy"
                  value={fields.dateDebut.value}
                  onChange={(e) => handleChangeSearch("dateDebut", e)}
                  renderInput={(params) => <TextField style={{ width: "inherit" }} {...params} />}
                />
                <DesktopDatePicker
                  label="Date fin"
                  inputFormat="dd/MM/yyyy"
                  value={fields.dateFin.value}
                  onChange={(e) => handleChangeSearch("dateFin", e)}
                  renderInput={(params) => <TextField style={{ width: "inherit" }} {...params} />}
                />
              </Stack>
            </LocalizationProvider>
          </div>
          <div style={{ display: "inline-flex", alignItems: "center" }}>
            <RestartAltIcon sx={{ m: 1 }} onClick={() => resetSearch()} />
          </div>
        </Stack>
      </MDBox>
      <DataTable
        table={{ columns, rows }}
        isSorted={false}
        entriesPerPage={false}
        showTotalEntries={false}
        noEndBorder
      />
    </>
  );
}

SalesTableData.propTypes = {
  subscriptions: PropTypes.oneOfType([PropTypes.array]).isRequired,
};

export default SalesTableData;
